import { render } from "./AcquisitionSearch.vue?vue&type=template&id=338218dc&scoped=true"
import script from "./AcquisitionSearch.vue?vue&type=script&lang=js"
export * from "./AcquisitionSearch.vue?vue&type=script&lang=js"

import "./AcquisitionSearch.vue?vue&type=style&index=0&id=338218dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338218dc"]])

export default __exports__